// extracted by mini-css-extract-plugin
export default {"container":"list-box-item-group_container__j7Oe2","active":"list-box-item-group_active__JaTeO"};